import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

interface PageNumberProps {
    stage?: string;
    sheetType?: string;
}

const styles = StyleSheet.create({
    container: {
        position: 'absolute',
        bottom: 10,
        left: 0,
        right: 0,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: 20,
    },
    center: {
        fontSize: 8,
        color: 'grey',
        textAlign: 'center',
    },
    right: {
        fontSize: 8,
        color: 'grey',
        textAlign: 'right',
        position: 'absolute',
        right: 20,
    },
});

const PageNumber: React.FC<PageNumberProps> = ({ sheetType = '' }) => {
    return (
        <View style={styles.container} fixed>
            <Text
                style={styles.center}
                render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
            />
            <Text style={styles.right}>{sheetType}</Text>
        </View>
    );
};

export default PageNumber;
